// * Loader
// *
// * Loader for home page

// const LOADING_CONFIG = {
// 	loading: '#loading-screen_box',
// }

// const loadingScreen = () => {
// 	let homePage = document.querySelector('#home')
// 	document.onreadystatechange = function () {
// 		if (document.readyState === 'complete') {
// 			if (homePage !== null) {
// 				// Loading
// 				setTimeout(function () {
// 					document.documentElement.scrollTop = 0
// 					document.getElementById('loading-screen_box').classList.add('hide')
// 					document.getElementById('loading-screen_overlay').classList.add('hide')
// 					document.getElementById('loading-screen_fake').classList.add('hide')
// 				}, 2000)
// 				// Anime menu
// 				setTimeout(function () {
// 					document.querySelector('#header .hero__items').classList.add('loadding-hide__menu--show')
// 					document.querySelector('#header .hero__items').classList.remove('loadding-hide__menu--hide')
// 				}, 2400)
// 			} else {
// 				anime({
// 					targets: 'body',
// 					opacity: [0, 1],
// 					easing: 'easeInQuad',
// 					duration: 900,
// 				})
// 			}
// 		}
// 	}
// }

// loadingScreen()

// Dragme of images with libraries
$(document).ready(function () {
	$(function () {
		function widthScreen() {
			let widthWindow = window.innerWidth
			return widthWindow / 2
		}

		let widthHalf = widthScreen()
		let $dragmeContainer = $('#dragme-container')
		let $dragMe = $('#dragme')
		if ($dragmeContainer.length === 0 || $dragMe.length === 0) return

		let imageAfter = document.querySelector('.top-home__pictures--figure.figure--summer')
		let imageBefore = document.querySelector('.top-home__pictures--figure.figure--winter')
		if (imageAfter === null || imageBefore === null) return

		// init aniamtion dragex
		animateTo(widthHalf)

		// updated images in move drage
		function updateImages() {
			let currentLeft = $dragMe.css('left')
			let newWidth = window.innerWidth - parseInt(currentLeft)
			let captionAfter = imageAfter.querySelector('figcaption')
			let captionBefore = imageBefore.querySelector('figcaption')

			// animation of titles
			if (imageBefore.offsetLeft < widthHalf) {
				onHide(captionAfter, 'active')
				onShow(captionBefore, 'active')
			} else if (imageBefore.offsetLeft > widthHalf) {
				onShow(captionAfter, 'active')
				onHide(captionBefore, 'active')
			} else {
				onHide(captionAfter, 'active')
				onHide(captionBefore, 'active')
			}

			// animation of images
			TweenLite.set(imageAfter, { width: currentLeft })
			TweenLite.set(imageBefore, { width: newWidth, left: currentLeft })
		}

		function animateTo(_left) {
			TweenLite.to($dragMe, 1, { left: _left, onUpdate: updateImages })
		}

		function onGoToSlider(param) {
			let quadsSlider = document.querySelector(`[data-tb-slick="carousel"] [data-tb-tag="${param}"]`)

			if (quadsSlider === null) return

			let $slider = $(quadsSlider.closest('[data-tb-slick="carousel"]'))
			let $sliderIndex = quadsSlider.parentElement === null ? 0 : parseInt(quadsSlider.parentElement.dataset.slickIndex)

			$slider.slick('slickGoTo', $sliderIndex)
		}

		function onHoverQuad(param) {
			let quadsHoverActive = document.querySelectorAll(`[data-tb-animation="hover"] [data-tb-tag].hover`)
			// remove class hover in quad
			quadsHoverActive.forEach((quadHover) => {
				onHide(quadHover, 'hover')
			})

			let quadsHover = document.querySelector(`[data-tb-animation="hover"] [data-tb-tag="${param}"]`)
			if (quadsHover !== null) {
				onShow(quadsHover, 'hover')
			}
		}

		function onFilterQuadBySeason(season) {
			switch (season) {
				case 'init':
					onHoverQuad(season)
					break

				case 'summer':
					onGoToSlider(season)
					onHoverQuad(season)
					break

				case 'winter':
					onGoToSlider(season)
					onHoverQuad(season)
					break
			}
			console.log(season)
		}

		let dragmeContainer = document.querySelector('#dragme-container')
		dragmeContainer.addEventListener('click', function (event) {
			let target = event.target,
				windowScreen = window.innerWidth,
				eventToClic = windowScreen / 2

			if (target.getAttribute('id') === 'expand-image-summer' || target.classList.contains('figure--summer')) {
				eventToClic = (windowScreen * 80) / 100
				onFilterQuadBySeason('summer')
			} else if (target.getAttribute('id') === 'expand-image-winter' || target.classList.contains('figure--winter')) {
				eventToClic = (windowScreen * 20) / 100
				onFilterQuadBySeason('winter')
			} else {
				onFilterQuadBySeason('init')
			}

			animateTo(eventToClic)
		})

		// resize window
		window.addEventListener('resize', function () {
			widthHalf = widthScreen()
			animateTo(widthHalf)
		})

		// create drage
		Draggable.create($dragMe, {
			type: 'left',
			bounds: $dragmeContainer,
			onDrag: updateImages,
		})
	})
})

// functions of project
;(function () {
	'use strict'

	// * Break Points
	// * Object break_points must be same as those used in project variables
	const BREAKS_POINTS = {
		XXL: 1480,
		MXL: 1380,
		XL: 1140,
		LG: 1090,
		MD: 920,
		MS: 768,
		S: 640,
		XS: 400,
	}

	// Constants
	const CLASS_NAME_SHOW$1 = 'down'
	const CLASS_NAME_SHOW$2 = 'up'
	const SELECTOR_ELEMENT$1 = '#header'

	let VALUE_SCROLL_TOP$1 = 0
	let VALUE_SCROLL_TOP$2 = 80

	// * Scroll
	// *
	// * Functions of scroll in of project

	// scrollW - Check scroll down or up for header styles
	const scrollW = () => {
		let SCROLL_TOP$1 = window.pageYOffset || document.documentElement.scrollTop
		let HEADER = document.querySelector(SELECTOR_ELEMENT$1)

		if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$2) {
			if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$1) {
				/* Code - Down Scroll */
				onShow(HEADER, CLASS_NAME_SHOW$1)
				onHide(HEADER, CLASS_NAME_SHOW$2)
			} else {
				/* Code - up Scroll */
				onHide(HEADER, CLASS_NAME_SHOW$1)
				onShow(HEADER, CLASS_NAME_SHOW$2)
			}
		} else {
			onHide(HEADER, CLASS_NAME_SHOW$1)
			onHide(HEADER, CLASS_NAME_SHOW$2)
		}

		VALUE_SCROLL_TOP$1 = SCROLL_TOP$1 <= 0 ? 0 : SCROLL_TOP$1
	}

	// * Focus
	// *
	// * Add class to parent element in to event required

	const FOCUS_ELEMENTS$1 = ['#email-signup_first_name', '#email-signup_last_name', '#email-signup_email_address', '.form-module .form-module__field input']
	const FOCUS_CLASS_NAME$1 = 'focus'

	// focusParent - Add class for focus element
	const focusParent = () => {
		FOCUS_ELEMENTS$1.forEach((element) => {
			let inputs = document.querySelectorAll(element)
			if (inputs === null) return null

			let parent_element

			inputs.forEach((input) => {
				input.addEventListener('focus', function (event) {
					event.preventDefault()

					parent_element = input.parentElement
					if (parent_element === null) return null

					onShow(parent_element, FOCUS_CLASS_NAME$1)
				})

				input.addEventListener('blur', function (event) {
					if (input.classList.contains('datepicker')) return null

					if (input.value !== '') return null

					event.preventDefault()

					parent_element = input.parentElement
					if (parent_element === null) return null

					onHide(parent_element, FOCUS_CLASS_NAME$1)
				})
			})
		})
	}

	// * Add custom properties
	// *
	// * Add custom properties in style of group
	const CUSTOM_PROPERTIES_SELECTOR$1 = '.group-start'

	const addCustomProperties = () => {
		let elements = document.querySelectorAll(CUSTOM_PROPERTIES_SELECTOR$1)
		let oldStyle, newStyle, imageBg

		elements.forEach((element) => {
			oldStyle = element.getAttribute('style')
			imageBg = [oldStyle.indexOf("('") + 2, oldStyle.indexOf("')")]
			newStyle = oldStyle.substring(imageBg[0], imageBg[1])

			// set new style
			element.setAttribute('style', `--group-start: url('${newStyle}')`)
		})
	}

	// * Overflow
	// *
	// * Overflow elements in event click
	const OVERFLOW_SELECTOR$1 = '[data-tb-overflow]'
	const OVERFLOW_ATTRIBUTE$1 = 'data-tb-overflow'
	const OVERFLOW_CLASS_NAME$1 = 'overflow-element'

	// overflow - Add overflow to indicated element
	const overflow = () => {
		let overflow = document.querySelectorAll(`${OVERFLOW_SELECTOR$1}`)

		overflow.forEach((element) => {
			let selector = getSelectorFromElement(element, OVERFLOW_ATTRIBUTE$1)

			if (selector) {
				let target = document.querySelector(selector)

				element.addEventListener('click', function (event) {
					event.preventDefault()

					onToggle(target, OVERFLOW_CLASS_NAME$1)
				})
			}

			return null
		})
	}

	// * Inner Texts
	// *
	// * Add texts to elements HTML

	// constants
	const INNER_TEXT_SELECTOR$1 = '.footer #email-signup'
	const INNER_TEXT_SELECTOR$2 = '.gdpr-wrap'
	const INNER_TEXT_SELECTOR$3 = '#attractions'
	const INNER_TEXT_ELEMENTS$1 = ['#signupformButton', '.pin-website', '.btn']

	const movePoliciesForm = () => {
		let FORM_MAIL = document.querySelector(INNER_TEXT_SELECTOR$1)
		let POLICIES = FORM_MAIL !== null ? FORM_MAIL.querySelector(INNER_TEXT_SELECTOR$2) : null

		if (FORM_MAIL !== null && POLICIES !== null) {
			FORM_MAIL.appendChild(POLICIES)
		}
	}

	// * Slider By Slick
	// *
	// * Slider to project with library "Slick"
	const SLIDER_SELECTOR$1 = '[data-tb-slick="gallery"]'
	const SLIDER_SELECTOR$2 = '[data-tb-slick="gallery-left"]'
	const SLIDER_SELECTOR$3 = '[data-tb-slick="gallery-right"]'
	const SLIDER_SELECTOR$4 = '[data-tb-slick="home"]'
	const SLIDER_SELECTOR$5 = '[data-tb-slick="filter-blog"]'
	const SLIDER_SELECTOR$6 = '[data-tb-slick="carousel"]'
	const SLIDER_SELECTOR$7 = '[data-tb-slick="reviews-block"]'
	const SLIDER_SELECTOR$8 = '[data-tb-slick="rooms-block"]'
	const SLIDER_SELECTOR$9 = '[data-tb-slick="accordion"]'
	const SLIDER_SELECTOR$10 = '[data-tb-slick="zoom-card"]'
	const SLIDER_SPEED$1 = 3000

	// * Settings Slick
	// *
	const SLICK_PROPS = {
		cssease: {
			linear: 'linear',
			ease_in_out: 'ease-in-out',
			ease_out: 'ease-out',
			cubic_bezier: 'cubic-bezier(0.7, 0, 0.3, 1)',
		},
		selectors: {
			arrowsHome: '.top-home__arrows--nav',
		},
		classnames: {
			slide_visible: 'slide-visible',
		},
	}

	// slickGallery
	const slickGallery = () => {
		let slickMain = document.querySelector(SLIDER_SELECTOR$1)
		if (slickMain === null) return

		let arrowPrev = slickMain.dataset.tbSlickPrev
		let arrowNext = slickMain.dataset.tbSlickNext

		$(SLIDER_SELECTOR$1).slick({
			fade: true,
			cssEase: SLICK_PROPS.cssease.cubic_bezier,
			arrows: true,
			slidesToShow: 1,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			asNavFor: `${SLIDER_SELECTOR$2}, ${SLIDER_SELECTOR$3}`,
			responsive: [
				{
					breakpoint: BREAKS_POINTS.MD,
					settings: {
						arrows: false,
						dots: true,
						asNavFor: null,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: BREAKS_POINTS.MS,
					settings: { arrows: false, dots: true, asNavFor: null, slidesToShow: 1, slidesToScroll: 1 },
				},
			],
		})

		$(SLIDER_SELECTOR$2).slick({
			draggable: false,
			arrows: false,
			slidesToShow: 1,
			responsive: [
				{
					breakpoint: BREAKS_POINTS.MD,
					settings: 'unslick',
				},
			],
		})

		$(SLIDER_SELECTOR$3).slick({
			draggable: false,
			arrows: false,
			slidesToShow: 2,
			variableWidth: true,
			responsive: [
				{
					breakpoint: BREAKS_POINTS.MD,
					settings: 'unslick',
				},
			],
		})
	}

	// slickHome
	const slickHome = () => {
		let slickCurrent = document.querySelector(SLIDER_SELECTOR$4) !== null ? document.querySelector(SLIDER_SELECTOR$4) : null
		if (slickCurrent === null) return

		$(slickCurrent).slick({
			lazyLoad: 'progressive',
			infinite: false,
			arrows: false,
			slidesToShow: 1.08,
			variableWidth: false,
			speed: 1000,
		})

		$(`#${slickCurrent.getAttribute('id')} [data-slick-goto]`).click(function () {
			const $currentSlider = $(this).closest(SLIDER_SELECTOR$4)
			const targetTo = $(this).data('slick-goto') ? $(this).data('slick-goto') : 0

			$currentSlider.slick('slickGoTo', parseInt(targetTo))
		})
	}

	// slickFilterBlog
	const slickFilterBlog = () => {
		$(SLIDER_SELECTOR$5)
			.slick({
				infinite: false,
				arrows: true,
				variableWidth: true,
				focusOnSelect: true,
			})
			.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				let target = event.target
				let sliderActive = target.querySelector(`[data-slick-index="${currentSlide}"] a[data-tb-target]:not(.active)`)

				if (sliderActive !== null) {
					sliderActive.click()
				}
			})
	}

	// slickCarousel
	const slickCarousel = () => {
		let elements = document.querySelectorAll(SLIDER_SELECTOR$6)

		$(SLIDER_SELECTOR$6).slick({
			fade: true,
			cssEase: SLICK_PROPS.cssease.ease_in_out,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: BREAKS_POINTS.MD,
					settings: {
						arrows: false,
						dots: true,
					},
				},
			],
		})

		elements.forEach((element) => {
			let slickCurrent = element.getAttribute('id')

			$(`#${slickCurrent} [data-slick-goto]`).click(function () {
				const $currentSlider = $(this).closest(SLIDER_SELECTOR$6)
				const targetTo = $(this).data('slick-goto') ? $(this).data('slick-goto') : 0

				$currentSlider.slick('slickGoTo', parseInt(targetTo))
			})
		})
	}

	// slickReviews
	const slickReviews = () => {
		let slickElement = document.querySelector(SLIDER_SELECTOR$7)
		if (slickElement === null) return

		let dotsAppend = slickElement.dataset.tbAppendDots !== undefined ? slickElement.dataset.tbAppendDots : ''

		$(slickElement).slick({
			fade: true,
			cssEase: SLICK_PROPS.cssease.cubic_bezier,
			arrows: false,
			dots: true,
			appendDots: $(dotsAppend),
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 4000,
			responsive: [
				{
					breakpoint: BREAKS_POINTS.S,
					settings: {
						autoplay: false,
					},
				},
			],
		})
	}

	// slickRooms
	const slickRooms = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$8)
		let elementPost

		slickElements.forEach((element) => {
			elementPost = element.dataset.tbSlickId === undefined ? '' : element.dataset.tbSlickId

			$(element).slick({
				fade: true,
				cssEase: SLICK_PROPS.cssease.cubic_bezier,
				arrows: true,
				dots: false,
				prevArrow: $(`#prev${elementPost}`),
				nextArrow: $(`#next${elementPost}`),
			})
		})
	}

	// slickAccordion
	const slickAccordion = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$9)

		slickElements.forEach((element) => {
			$(element).slick({
				fade: true,
				cssEase: SLICK_PROPS.cssease.cubic_bezier,
				arrows: false,
				dots: true,
				adaptiveHeight: true,
			})
		})
	}

	// slickCards
	const slickCards = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$10)

		slickElements.forEach((element) => {
			$(element).slick({
				fade: true,
				cssEase: SLICK_PROPS.cssease.cubic_bezier,
				arrows: false,
				dots: true,
				adaptiveHeight: true,
			})
		})
	}

	$('.slider-months__mobile').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "0px"
    });

	// * Reactivity with events
	// *
	// * Functions for the use of in events quads

	const EVENTS_SELECTOR$1 = '[data-tb-events="accordion"]'
	const EVENTS_SELECTOR$2 = '[data-tb-events="collapse"]'
	const EVENTS_SELECTOR$3 = '[data-tb-events="collapse"]'
	const EVENTS_SELECTOR$4 = '[data-tb-events="collapse"][data-tb-target="#booking-overlay"]'
	const EVENTS_SELECTOR$5 = '[data-tb-events="accordion-nav"]'
	const EVENTS_SELECTOR$6 = ['.privary-navigation__list .privary-navigation__item .submenu']
	const EVENTS_SELECTOR$7 = '[data-tb-events="hover-video"]'
	const EVENTS_CONFIG = {
		classnames: {
			active: 'active',
			activeParent: 'active-parent',
			show: 'show',
			hide: 'hide',
			open: 'open',
			openBooking: 'open-booking',
			closeBooking: 'close-booking',
		},
		attributes: {
			data_target: 'data-tb-target',
		},
		selectores: {
			menusActive: '.privary-navigation .submenu .active',
			dragmeContainer: '[data-tb-dragme="container"]',
			dragmeDragme: '[data-tb-dragme="container"] [data-tb-dragme="dragme"]',
		},
	}

	const eventsAccordion = () => {
		let elements = document.querySelectorAll(EVENTS_SELECTOR$1)
		let target, parentPost, parentBox, targetText, activesText, activesHide, actives

		elements.forEach((element) => {
			element.addEventListener('click', function (event) {
				target = event.target // current target
				parentPost = target.closest('[data-tb-post]') // search post parent of target
				parentBox = target.closest('[data-tb-quad]') // search post parent
				targetText = target.nextElementSibling // search element by text of parent

				if (target.dataset.tbAccordion !== undefined && !parentPost.classList.contains(EVENTS_CONFIG.classnames.active)) {
					event.preventDefault()

					// updated nav
					let navigationBox = parentBox.querySelector(EVENTS_SELECTOR$5)
					let numberActive = navigationBox.querySelectorAll(`[data-tb-index].${EVENTS_CONFIG.classnames.active}`)
					numberActive.forEach((element) => {
						onHide(element, EVENTS_CONFIG.classnames.active)
					})

					// add class active of element
					let currentElement = navigationBox.querySelector(`[data-tb-index="${target.dataset.tbAccordion}"]`)
					currentElement && onShow(currentElement, EVENTS_CONFIG.classnames.active)

					activesText = element.querySelectorAll(`.show[data-tb-accordion="text"]`) // search element of data-tb-event='accordion' with classname hide
					activesText.forEach((elementActive) => {
						onHide(elementActive, EVENTS_CONFIG.classnames.show)
						onHide(elementActive.childNodes[0], EVENTS_CONFIG.classnames.show)
					})

					activesHide = element.querySelectorAll(`.hide[data-tb-accordion]`) // search element of data-tb-event='accordion' with classname hide
					actives = element.querySelectorAll(`.active[data-tb-post]`) // search elements of data-tb-event='accordion' with classname active
					activesHide.forEach((elementActive) => {
						onHide(elementActive, EVENTS_CONFIG.classnames.hide)
					})
					actives.forEach((elementActive) => {
						onHide(elementActive, EVENTS_CONFIG.classnames.active)
					})

					onShow(parentPost, EVENTS_CONFIG.classnames.active) // and add classname active
					onToggle(target, EVENTS_CONFIG.classnames.hide) // add classname hide for target

					setTimeout(() => {
						onShow(targetText, EVENTS_CONFIG.classnames.show) // add classname hide for target
					}, 400)

					setTimeout(() => {
						onShow(targetText.childNodes[0], EVENTS_CONFIG.classnames.show)
					}, 500)
				}
			})
		})
	}

	const eventsCollapse = () => {
		let elements = document.querySelectorAll(EVENTS_SELECTOR$2)

		elements.forEach((element) => {
			let selector = getSelectorFromElement(element, EVENTS_CONFIG.attributes.data_target)
			if (selector === null) return

			let target = document.querySelector(selector)

			element.addEventListener('click', function (event) {
				event.preventDefault()

				onToggle(target, EVENTS_CONFIG.classnames.show)
				onToggle(element, EVENTS_CONFIG.classnames.open)
			})
		})
	}

	const eventsBooking = () => {
		let element = document.querySelector(EVENTS_SELECTOR$4)
		let header

		element.addEventListener('click', function (event) {
			event.preventDefault()

			if (element.dataset.tbState === '0') {
				element.setAttribute('data-tb-text', 'Close')
				element.setAttribute('data-tb-state', '1')
				header = document.querySelector(SELECTOR_ELEMENT$1)

				onShow(header, EVENTS_CONFIG.classnames.openBooking)
				onHide(header, EVENTS_CONFIG.classnames.closeBooking)
			} else if (element.dataset.tbState === '1') {
				element.setAttribute('data-tb-text', 'Book Now')
				element.setAttribute('data-tb-state', '0')
				header = document.querySelector(SELECTOR_ELEMENT$1)

				onHide(header, EVENTS_CONFIG.classnames.openBooking)
				onShow(header, EVENTS_CONFIG.classnames.closeBooking)
			}
		})
	}

	const eventsMenuSubMenu = () => {
		let elementsActive = document.querySelectorAll(EVENTS_CONFIG.selectores.menusActive)

		elementsActive.forEach((elementActive) => {
			let submenuParent = elementActive && elementActive.closest('.submenu')
			if (submenuParent === null) return

			let parentActive = submenuParent.previousElementSibling
			if (parentActive === null) return

			onShow(parentActive, EVENTS_CONFIG.classnames.activeParent)
		})
	}

	const eventsAccordionNav = () => {
		let elements = document.querySelectorAll(EVENTS_SELECTOR$5)
		let target, parent, parentBox, activeElement, numberTemp, totalAccordion

		elements.forEach((element) => {
			element.addEventListener('click', function (event) {
				target = event.target
				if (target && target.dataset.tbArrow !== undefined) {
					parent = target.closest('[data-tb-events]')
					totalAccordion = parseInt(parent.dataset.tbTotal)
					activeElement = parent.querySelector('[data-tb-index].active')

					if (activeElement && target.classList.contains('arrow--next')) {
						numberTemp = parseInt(activeElement.dataset.tbIndex) + 1
						numberTemp = numberTemp > totalAccordion ? 1 : numberTemp
					} else if (activeElement && target.classList.contains('arrow--prev')) {
						numberTemp = parseInt(activeElement.dataset.tbIndex) - 1
						numberTemp = numberTemp === 0 ? totalAccordion : numberTemp
					} else {
						numberTemp = 1
					}

					// remove number actives
					let numberActive = parent.querySelectorAll(`[data-tb-index].${EVENTS_CONFIG.classnames.active}`)
					numberActive.forEach((element) => {
						onHide(element, EVENTS_CONFIG.classnames.active)
					})

					// click in element
					parentBox = target.closest('[data-tb-quad]')
					let accordionClick = parentBox.querySelector(`[data-tb-accordion="${numberTemp}"]`)
					accordionClick && accordionClick.click()

					// add class active in element
					let numberClick = parent.querySelector(`[data-tb-index="${numberTemp}"]`)
					onShow(numberClick, EVENTS_CONFIG.classnames.active)
				}
			})
		})
	}

	const eventsHover = () => {
		let selectors = document.querySelectorAll(EVENTS_SELECTOR$6)

		selectors.forEach((selector) => {

			let element = selector.parentNode;
				element.addEventListener('mouseover', ()=>{
					element.querySelector('.submenu').classList.add('active');
				})
				element.addEventListener('mouseout', ()=>{
					element.querySelector('.submenu').classList.remove('active');
				})
		})
	}

	const eventsHoverVideos = () => {
		const mouseVideos = document.querySelectorAll(EVENTS_SELECTOR$7)

		mouseVideos.forEach((video) => {
			if (window.screen.width > BREAKS_POINTS.LG) {
				video.addEventListener('mouseenter', () => {
					if (video.paused) {
						video.play()
					}
				})

				video.addEventListener('ended', function () {
					this.currentTime = 0
				})
			} else {
				video.autoplay = true
				video.addEventListener('ended', function () {
					this.play()
				})
			}
		})
	}

	// * DatePicker
	// *
	// * Functions for datepciker in project

	const SELECTOR_DATEPICKER$1 = '.booking_datepicker'

	const SELECTOR_DATE$1 = '#CheckIn'
	const SELECTOR_DATE$2 = '#CheckOut'
	const SELECTOR_DATE$3 = '#checkInDate'
	const SELECTOR_DATE$4 = '#checkOutDate'

	let opened = 0
	let start = $(SELECTOR_DATE$1).attr('value')
	let end = $(SELECTOR_DATE$2).attr('value')
	const DATE_FORMAT = $(SELECTOR_DATE$1).data('format') !== undefined && $(SELECTOR_DATE$1).data('format') ? $(SELECTOR_DATE$1).data('format') : 'yy-mm-dd'

	const calendarRange = (date) => {
		let DATE_STYLE = [true]
		let startDate = $.datepicker.parseDate(DATE_FORMAT, $(SELECTOR_DATE$1).val())
		let endDate = $.datepicker.parseDate(DATE_FORMAT, $(SELECTOR_DATE$2).val())

		if (date.getTime() == startDate.getTime()) return [true, 'startday']

		if (date.getTime() == endDate.getTime()) return [true, 'endday']

		if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) return [true, 'days']

		return [true, '']
	}

	const datepickerBooking = () => {
		let laterDate = new Date()
		laterDate = laterDate.setDate(laterDate.getDate() + 1)

		$(SELECTOR_DATE$1).datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: new Date(),
			nextText: '',
			prevText: '',
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 1)
				$(SELECTOR_DATE$2).datepicker('setDate', newDate)
				$(SELECTOR_DATE$2).datepicker('option', 'minDate', selectedDate)
			},
		})

		$(SELECTOR_DATE$2).datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: new Date(laterDate),
			nextText: '',
			prevText: '',
			beforeShowDay: (date) => calendarRange(date),
		})
	}

	// * Fancybox
	// *
	// * Settings of fancybox

	$('[data-fancybox]').fancybox({
		btnTpl: {
			// Arrows
			arrowLeft:
				'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
				'<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0.4 0.79 32.43 16.09" fill="#fff"><path d="M13.741 16.647a.812.812 0 0 0 1.146-1.152l-5.8-5.773h3.763L19.66 16.5a.812.812 0 0 0 1.146-1.15l-5.653-5.63h3.616l6.809 6.779a.811.811 0 0 0 1.145-1.15L21.07 9.72h10.95a.812.812 0 0 0 0-1.624H20.774l5.946-5.92a.81.81 0 0 0 .002-1.147.811.811 0 0 0-1.148-.003l-7.102 7.07h-3.616l5.946-5.92a.808.808 0 0 0 .238-.575.812.812 0 0 0-1.384-.575l-7.101 7.07h-3.47l5.8-5.774a.812.812 0 0 0-1.146-1.15L6.784 8.096H3.168l5.8-5.775a.812.812 0 0 0-1.146-1.15L.63 8.332a.837.837 0 0 0 0 1.15l7.192 7.162a.812.812 0 0 0 1.146-1.15l-5.8-5.775h3.616z"></path></svg></div>' +
				'</button>',

			arrowRight:
				'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
				'<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0.39 0.77 32.43 16.09" fill="#fff"><path d="M19.477 1.01a.811.811 0 0 0-1.145 1.15l5.8 5.775h-3.763l-6.81-6.78a.812.812 0 0 0-1.146 1.15l5.654 5.63h-3.616L7.642 1.157a.811.811 0 0 0-1.146 1.151l5.653 5.63H1.2a.812.812 0 0 0 0 1.624l11.246-.002L6.5 15.48a.81.81 0 0 0-.002 1.148c.316.318.83.32 1.148.003l7.102-7.07h3.616l-5.946 5.92a.81.81 0 0 0-.002 1.147.81.81 0 0 0 1.147.003l7.102-7.07h3.47l-5.8 5.774a.812.812 0 0 0 1.146 1.15l6.955-6.924h3.616l-5.8 5.774a.812.812 0 0 0 1.146 1.151l7.192-7.162a.838.838 0 0 0 0-1.15L25.397 1.01a.812.812 0 0 0-1.146 1.151l5.8 5.774h-3.616z"></path></svg></div>' +
				'</button>',
		},
	})

	// * Observer
	// *
	// * Observer events for animations o actions
	const OBSERVER_CONFIG = {
		targets: {
			accordion: '.accordion[data-tb-quad]',
			accordionItem: '.accordion__item[data-tb-post] [data-tb-accordion]',
		},
	}

	const observerInitAccordion = () => {
		let elements = document.querySelectorAll(OBSERVER_CONFIG.targets.accordion)

		let optionsObserver = {
			root: null,
			rootMargin: '0px',
			threshold: 0.8,
		}

		function callbackObserver(entries, observer) {
			for (let entry of entries) {
				if (entry.isIntersecting) {
					entry.target.click()
				}
			}
		}

		elements.forEach((element) => {
			let elementClick = element.querySelector(OBSERVER_CONFIG.targets.accordionItem)
			if (elementClick === null) return

			let observerP = new IntersectionObserver(callbackObserver, optionsObserver)
			observerP.observe(elementClick)
		})
	}

	// * Content Loaded
	// *
	// * DOM Content Loaded is ready available
	// * @param {*} callback

	const onDOMLoaded = (callback) => {
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			document.addEventListener('DOMContentLoaded', () => {
				setTimeout(callback, 1)
			})
		} else {
			document.addEventListener('DOMContentLoaded', callback)
		}
	}

	onDOMLoaded(
		// * This function add a class to header when scroll down the page
		// * and change the logo by a new file if needed depending of mockup

		scrollW(),
		window.addEventListener('scroll', function () {
			scrollW()
		}),

		// Focus
		focusParent(),

		// Custom Properties
		addCustomProperties(),

		// Overflow
		overflow(),

		// Inner text
		movePoliciesForm(),

		// Slick
		slickGallery(),
		slickHome(),
		slickFilterBlog(),
		slickCarousel(),
		slickReviews(),
		slickRooms(),
		slickAccordion(),
		slickCards(),

		// EventsReactivity
		eventsAccordion(),
		eventsCollapse(),
		eventsBooking(),
		eventsMenuSubMenu(),
		eventsAccordionNav(),
		eventsHover(),
		eventsHoverVideos(),

		// datepicker
		datepickerBooking(),

		// observer
		observerInitAccordion()
	)
})()
